<template>
  <div class="Kanit" style="height: 100vh; width: 100vw; overflow-y: scroll;">
    <!-- <section id="first" class="current"> -->
    <div style="min-height: 100vh;" aos="fade">

<v-layout row wrap>
      <v-flex sm5 md5 lg5 xl5 style="text-align: right;">
        <img src="img/aed_cover.png" style="    margin-top: 15vh;    max-height: 80vh;
    max-width: 100vw;object-fit: cover;
  object-position: 50% 0;" />
      </v-flex>
      <v-flex sm7 md7 lg7 xl7 style="text-align: center;margin-top: 5vh; padding: 60px;">
        <p class="colorHeader p-20" style="font-size: 45px; font-weight: 600;">Application AED กระตุกหัวใจ</p>
        <p class="colorDes" style="text-indent: 30px;font-size: 16px;text-align: left;">แอปพลิเคชั่นสำหรับค้นหาตำแหน่งเครื่อง AED ในประเทศไทย สามารถค้นหาเครื่อง AED และอาสาสมัครผู้ทำ CPR ในระยะใกล้ๆคุณ มีการสอนวิธีการใช้งานเครื่อง AED และวิธีการทำ CPR ภายในแอป</p>
<img src="img/qrcodeDownload.png" style="    margin-top: 5vh;height: 150px;object-fit: cover;
  object-position: 50% 0;" />
  <p class="colorDes" style="font-size: 16px;text-align: center; margin: 0 !important;">Scan เพื่อดาวน์โหลดแอปพลิเคชัน</p>
  <p class="colorDes" style="font-size: 13px;text-align: center;"> ** รองรับทั้งในระบบ andriod และ ios</p>

<v-layout row wrap>
  <v-flex xs12 sm12 md12 lg12 xl12 style="display: inherit;" hidden-sm-and-down>
    <div style="margin: auto;">
      <img src="download/appstore.png" style="height: 50px;object-fit: cover; object-position: 50% 0;" @click="download()"/>
      <img src="download/googleplay.png" style="margin-left:20px;height: 50px;object-fit: cover; object-position: 50% 0;" @click="download()"/>
    </div>
  </v-flex>

  <v-flex xs12 sm12 md12 lg12 xl12 style="display: inherit;" hidden-md-and-up>
    <div style="margin: auto;">
      <img src="download/appstore.png" style="height: 50px;object-fit: cover; object-position: 50% 0;" @click="download()"/>
      <img src="download/googleplay.png" style="height: 50px;object-fit: cover; object-position: 50% 0;" @click="download()"/>
    </div>
  </v-flex>
</v-layout>




      </v-flex>

     


    </v-layout>


    </div>
 <!--  </section>





<section id="second"> -->
    <div>
    <v-layout row wrap style="align-items: center;" justify-center class="backgroundRadius p-20 ">
      
      <v-flex xs12 sm12 md3 lg3 xl3 style="text-align: right;" hidden-sm-and-down>
        <h2 class="colorHeader">สำหรับผู้ใช้ทั่วไป</h2>
        <p style="text-indent: 30px;font-size: 16px;" class="colorDes backgroundDes">
          ตัวอย่างวิธีการใช้งานแอปพลิเคชัน AED กระตุกหัวใจ สำหรับผู้ใช้งานประเภททั่วไป
        </p>
      </v-flex>

      <v-flex xs12 sm12 md8 lg8 xl8 style=" text-align: center; max-height: 40vh;">
        <iframe src="https://www.youtube.com/embed/xFnxkQg2DP8" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="videoYoutube"></iframe>
      </v-flex>
      <v-flex xs12 sm12 md3 lg3 xl3 style="text-align: right;" hidden-md-and-up>
        <h2 class="colorHeader">สำหรับผู้ใช้ทั่วไป</h2>
        <p style="text-indent: 30px;font-size: 16px;" class="colorDes backgroundDes">
          ตัวอย่างวิธีการใช้งานแอปพลิเคชัน AED กระตุกหัวใจ สำหรับผู้ใช้งานประเภททั่วไป
        </p>
      </v-flex>

      <v-flex xs12 sm12 md8 lg8 xl8 style="margin-top: 20px; max-height: 40vh;">
        <iframe src="https://www.youtube.com/embed/3dnQ6rvrvYM" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="videoYoutube"></iframe>
      </v-flex>

      <v-flex xs12 sm12 md3 lg3 xl3 style="text-align: left;">
        <h2 class="colorHeader">สำหรับแอดมิน</h2>
        <p style="text-indent: 30px;font-size: 16px;" class="colorDes backgroundDes">
          อธิบายวิธีการใช้งานแอปพลิเคชัน AED กระตุกหัวใจ สำหรับผู้ใช้งานประเภทแอดมิน
        </p>
      </v-flex>







      <v-flex sm12 md12 lg12 xl12 style="margin-top: 50px;">
        <h2 class="colorHeader">ดาวน์โหลดคู่มือการใช้งาน</h2>
      </v-flex>




<v-flex sm12 md12 lg12 xl12 >
  <v-layout row wrap justify-center >
      <v-flex  xs12 sm12 md2 lg2 xl2 style="padding: 10px; text-align: center; cursor: pointer;">
        <div  class="colorDes backgroundDesFile" style="height: 144px;" @click="openPDF('superadmin')">
          <div style="text-align: center;">
            <v-icon class="iconFile">fas fa-file-pdf</v-icon>
        </div>
          <p style="margin-top: 15px;font-size: 16px; color: #b22c25e6;">คู่มือสำหรับ<br/>Admin</p>
       


        </div>
        <v-btn color="#a80f00" small @click="downloadPDF('admin')" v-on="on" style="color: white;box-shadow: none;
    border-radius: 20px; font-size: 12px;">
            ดาวน์โหลด
          </v-btn>
      </v-flex>

      <v-flex xs12 sm12 md2 lg2 xl2 style="padding: 10px; text-align: center; cursor: pointer;" >
        <div class="colorDes backgroundDesFile" style="height: 144px;" @click="openPDF('superadmin')">
          <div style="text-align: center;">
            <v-icon class="iconFile">fas fa-file-pdf</v-icon>
        </div>
          <p style="margin-top: 15px;font-size: 16px;color: #b22c25e6;">คู่มือสำหรับ Superadmin</p>


        </div>
        <v-btn color="#a80f00" small @click="downloadPDF('superadmin')" v-on="on" style="color: white;box-shadow: none;
    border-radius: 20px; font-size: 12px;">
            ดาวน์โหลด
          </v-btn>
      </v-flex>
    </v-layout>
    </v-flex>




    </v-layout>
  </div>
<!-- </section> -->
  </div>
</template>

<script>
export default {
  props: {
    msg: String
  },
  data: () => ({
    fileDetail: {
      admin: {link: 'https://aed.redcross.or.th/api/v1/profile_picture/%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%83%E0%B8%8A%E0%B9%89%E0%B8%87%E0%B8%B2%E0%B8%99%20AED%20%E0%B8%AA%E0%B8%B3%E0%B8%AB%E0%B8%A3%E0%B8%B1%E0%B8%9A%20Admin%20(Update%2022-Oct-2020).pdf', name: 'คู่มือการใช้งาน Application AED กระตุกหัวใจ สำหรับ Admin.pdf'},
      superadmin: {link: 'https://aed.redcross.or.th/api/v1/profile_picture/%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%83%E0%B8%8A%E0%B9%89%E0%B8%87%E0%B8%B2%E0%B8%99%20AED%20%E0%B8%AA%E0%B8%B3%E0%B8%AB%E0%B8%A3%E0%B8%B1%E0%B8%9A%20SuperAdmin%20(Update%2022-Oct-2020).pdf', name: 'คู่มือการใช้งาน Application AED กระตุกหัวใจ สำหรับ Superadmin.pdf'}
    }
  }),
  mounted() {
    var yourDiv = $('#divID').offset();
    $('html, body').animate({scrollTop: yourDiv.top}, "slow");
  },
  methods: {
    downloadPDF (file) {
      this.axios.get(this.fileDetail[file]['link'], { responseType: 'blob' }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', this.fileDetail[file]['name'])
        document.body.appendChild(link)
        link.click()
      })
    },
    openPDF (file) {
      window.open(this.fileDetail[file]['link'], "_blank")
    },
    download () {
      window.open('http://onelink.to/ctkd5a').focus()
    }
  }
  // data: () => ({
  //   dates: ['2019-09-10', '2019-09-20'],
  // }),
  // computed: {
  //   dateRangeText () {
  //     return this.dates.join(' ~ ')
  //   },
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.colorHeader {
  color: #a80d00;
}
.colorDes {
  color: #a80d00c7;

}
.backgroundDes {
  background: #eccac847;
    border-radius: 5px;
    padding: 10px;
}

.backgroundDesFile {
  background: #f7f7f7d6;
    border-radius: 5px;
    padding: 10px;
}
.backgroundDesFile:hover {
  background: #efd2a191 !important;
}
.backgroundRadius {
  background: #eccac85c;
  border-radius: 20px;
  margin: 5vh 10vw;
}
.p-20 {
  padding: 20px;
}

.iconFile {
  color: #a80e00 !important;
  font-size: 50px !important;
}

.videoYoutube {
  min-width: 42vw;
    min-height: 30vh;
    max-height: 40vh;
    border-radius: 8px;
}

</style>
